import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from '../../../contexts/translation';
export interface DialogProps {
  open: boolean;
  title: string;
  content: string;
  handleClose: (e: any) => void;
  handleConfirm: (e: any) => void;
  hideButtons?: boolean;
}

export function AlertDialog({
  open,
  title,
  content,
  handleClose,
  handleConfirm,
  hideButtons,
}: DialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={handleClose} maxWidth={'xs'} fullWidth>
      <Box px={2} py={1}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Box py={1}>{content}</Box>
        </DialogContent>
        {!hideButtons && (
          <DialogActions>
            <Button onClick={handleClose} color="primary" variant={'outlined'}>
              {t('general.action-buttons.close')}
            </Button>
            <Button onClick={handleConfirm} color="primary" variant={'contained'}>
              {t('general.action-buttons.confirm')}
            </Button>
          </DialogActions>
        )}
      </Box>
    </Dialog>
  );
}
